import * as React from 'react'

import queryString from 'query-string'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { bindActionCreators, compose } from 'redux'
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form'
import SnackbarService from 'services/snackbars'
import { getParamFromUrl } from 'services/utils'
import { isPasswordStrong } from 'services/validate'
import * as UserActions from '../../store/user/actions'
import Content from './content'
import './style.scss'

interface IProps
  extends InjectedFormProps,
    RouteComponentProps<{ userRole: string }> {
  signUpParentForm?: any
  UserLib?: any
  fullName: string
  email: string
}

interface IState {
  page: string
  loading: boolean
  formSubmitted: boolean
  agreeWithTerms: boolean
}

interface IOnetimeWarnings {
  passwordIsTooSimple: boolean
}

class CreatePassword extends React.Component<IProps, IState> {
  state: IState = {
    page: 'form',
    loading: false,
    formSubmitted: false,
    agreeWithTerms: false
  }

  onetimeWarnings: IOnetimeWarnings = {
    passwordIsTooSimple: false
  }

  updateOneTimeWarning = (key: keyof IOnetimeWarnings) =>
    (this.onetimeWarnings[key] = true)

  keyPressed = (e: KeyboardEvent) => {
    switch (e.keyCode) {
      case 13:
        this.enterPressed(e)
        break
      default:
        break
    }
  }

  enterPressed = e => {
    e.preventDefault()
    this.onSubmit()
  }

  componentDidMount() {
    const {
      history: {
        location: { state }
      }
    } = this.props

    document.addEventListener('keydown', this.keyPressed)

    if (state && this.state.page) {
      this.setState({ page: this.state.page })
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyPressed)
  }

  setAgreeWithTerms = (val: boolean = true) =>
    this.setState({ agreeWithTerms: val })

  onSubmit = async () => {
    const { page, agreeWithTerms } = this.state
    const { signUpParentForm } = this.props

    this.setState({
      formSubmitted: true
    })

    if (
      !isPasswordStrong(signUpParentForm.password) &&
      !this.onetimeWarnings.passwordIsTooSimple
    ) {
      SnackbarService.showSnackbar(
        'We suggest a strong password with at least 1 lowercase letter, 1 uppercase letter, and 1 digit',
        'info'
      )
      this.updateOneTimeWarning('passwordIsTooSimple')
      return
    }

    if (!agreeWithTerms) {
      SnackbarService.showSnackbar(
        'Please accept our Privacy Policy and Terms of Use',
        'error'
      )
      return
    }

    if (page === 'form') {
      this.doSignUp()
      return
    }
  }

  doSignUp = async () => {
    const { valid, signUpParentForm } = this.props
    if (!signUpParentForm) {
      SnackbarService.showSnackbar(
        'Sorry, something went wrong (Error 4), Please contact support@giantleap.tech',
        'error'
      )
    }
    let signUpData: any = null
    signUpData = {
      ...signUpParentForm,
      full_name: `${signUpParentForm.pName} ${signUpParentForm.pLastName}`
    }

    if (!signUpData) {
      SnackbarService.showSnackbar('Error occured!', 'error')
      return
    } else if (!valid) {
      SnackbarService.showSnackbar('Please, enter valid data!', 'error')
      return
    }

    this.setState({ loading: true })
    this.doSignUpAsync('parent', signUpData)
  }

  onChangeSelect = (name: string, value: string) => {
    this.props.change(name, value)
  }

  onChangeMaskedInput = (name: string, value: string) => {
    this.props.change(name, value)
  }

  checkUrlparams = () => {
    const params = queryString.parse(this.props.location.search)
    let pName = ''
    let pLastName = ''
    let email = ''
    if (params.first_name) {
      pName = params.first_name
    }
    if (params.last_name) {
      pLastName = params.last_name
    }
    if (params.email) {
      email = params.email
    }
    let errorMsg = ''
    if (pName === '' || pLastName === '' || email === '') {
      errorMsg =
        'Sorry, something went wrong (Error 1), Please contact support@giantleap.tech'
      if (pName === '') {
        errorMsg = 'First name is missing'
      } else if (pLastName === '') {
        errorMsg = 'Last name is missing'
      } else if (email === '') {
        errorMsg = 'Email is missing'
      }
      if (pName === '' && pLastName === '' && email === '') {
        errorMsg = 'All fields are missing'
      }
      const x =
        window.location.href.indexOf('create_password') +
        'create_password'.length
      if (window.location.href.substring(x).includes('password=')) {
        errorMsg =
          'Sorry, something went wrong (Error 2), Please contact support@giantleap.tech'
      }
      SnackbarService.showSnackbar(errorMsg, 'error')
      const urlparams = window.location.href.substring(x).includes('password=')
        ? ''
        : window.location.href.substring(x)
      setTimeout(
        () => (window.location.href = '/signup/parent' + urlparams),
        1000
      )
    }
  }

  render() {
    const { page, loading, formSubmitted, agreeWithTerms } = this.state
    const {
      valid,
      anyTouched,
      match: {
        params: { userRole }
      }
    } = this.props
    this.checkUrlparams()

    return (
      <>
        <Content
          isValidForm={valid}
          isAnyTouched={anyTouched}
          formSubmitted={formSubmitted}
          userRole={userRole}
          onChangeMaskedInput={this.onChangeMaskedInput}
          page={page}
          onSubmit={this.onSubmit}
          loading={loading}
          agreeWithTerms={agreeWithTerms}
          setAgreeWithTerms={this.setAgreeWithTerms}
        />
      </>
    )
  }

  private doSignUpAsync = (
    userRole: string,
    signUpData: any,
    url: string = ''
  ) => {
    signUpData.email = signUpData.email.toLowerCase()
    this.props.UserLib.signUp(
      userRole,
      {
        ...signUpData,
        avatar_url: url
      },
      async () => {
        this.setState({
          page: 'registered',
          loading: false
        })
        this.props.history.push('/children_list')
      },
      (errorMessage: string) => {
        SnackbarService.showSnackbar(errorMessage, 'error')
        this.setState({ loading: false })
        // email allready exist
      }
    )
  }
}

const SignUpContainer = reduxForm({
  form: 'signup'
})(CreatePassword)

const selector = formValueSelector('signup')

const mapStateToProps = (state, ownProps) => {
  const signUpParentForm = {
    pName: (selector(state, 'pName') || '').trim(),
    pLastName: (selector(state, 'pLastName') || '').trim(),
    pPhone: selector(state, 'pPhone') || '',
    email: (selector(state, 'email') || '').trim(),
    password: selector(state, 'password') || ''
  }

  const {
    location: { search },
    history: {
      location: { state: historyState }
    }
  } = ownProps
  const pName = decodeURIComponent(getParamFromUrl(search, 'first_name')).split(
    '+'
  )[0]
  const pLastName = decodeURIComponent(
    getParamFromUrl(search, 'last_name')
  ).split('+')[0]
  const email = decodeURIComponent(getParamFromUrl(search, 'email'))
  if (decodeURIComponent(getParamFromUrl(search, 'password')).split('+')[0]) {
    SnackbarService.showSnackbar(
      'Sorry, something went wrong (Error 5), Please contact support@giantleap.tech',
      'error'
    )
    setTimeout(() => (window.location.href = '/signup/parent'), 1000)
  }
  const initialValues = {
    email: (historyState && historyState.email) || email,
    pName: (historyState && historyState.name) || pName,
    pLastName: (historyState && historyState.lastName) || pLastName,
    password: historyState && historyState.password
  }

  return {
    ...signUpParentForm,
    signUpParentForm,
    initialValues
  }
}

const mapDispatchToProps = dispatch => {
  return {
    UserLib: bindActionCreators<any, any>(UserActions as any, dispatch)
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps)

export default compose(withRouter, connector)(SignUpContainer)



// WEBPACK FOOTER //
// ./src/pages/CreatePassword/index.tsx